// The 401 handler for configureBackends' `onUnauthorized` — the fix from the
// dead-logout-button bug, promoted into the SDK so the next surface cannot
// re-introduce the race.
//
// Two rules, both load-bearing:
//   1. Single flight: a burst of parallel 401s produces ONE redirect, ever —
//      the latch never resets, because the redirect is a full page load.
//   2. The sign-out stand-down: during logout, teardown requests 401 as state
//      clears. Hijacking the in-flight hosted-logout navigation with a
//      /login redirect leaves the provider's session alive, and the next
//      on-load login signs the user straight back in silently.
import { brokeredLogin } from './brokeredLogin.js';
import { clearSession } from './sessionTokenStorage.js';

/**
 * @param {Object} options
 * @param {String} [options.redirectTo] Where a dead session lands ('/login').
 * @param {Function} [options.navigate] Override for the page navigation —
 *   defaults to window.location.assign; a host with a router may inject its
 *   own. Never called when already at redirectTo, or while signing out.
 */
export function createUnauthorizedHandler({ redirectTo = '/login', navigate } = {}) {
    let handled = false;
    return function onUnauthorized() {
        if (handled) return;
        handled = true;
        clearSession().finally(() => {
            if (brokeredLogin.isSigningOut()) return;
            if (typeof window === 'undefined') return;
            if (window.location.pathname === redirectTo) return;
            (navigate || window.location.assign.bind(window.location))(redirectTo);
        });
    };
}
